import Vue from "vue";
import VueRouter from "vue-router";

import FormSelector from "./components/FormSelector";
import Success from "./components/Success";

Vue.use(VueRouter);

const routes = [
  { path: "/success", name: "success-page", component: Success },
  { path: "/", name: "form", component: FormSelector },
  { path: "/*", name: "form-steps", component: FormSelector },
];

export const router = new VueRouter({ routes });
